// src/data/packages-part1.js
// Part 1 — Packages 1..20 (International only — no India packages)
// Image choice: option C (image: mainImage, images: [5 images with main repeated first])

const packages = [
 

 {
  id: 2,
  name: "Oceanview Bay Hotel",
  destination: "Crete",
  country: "Greece",
  nights: 7,
  boards: [
    { type: "Room Only", price: 219 },
    { type: "Bed & Breakfast", price: 269 },
    { type: "All Inclusive", price: 409 }
  ],

  // Main display image
  image: "/images/packages/oceanview-bay-hotel-1.jpg",

  // Gallery images
  images: [
    "/images/packages/oceanview-bay-hotel-1.jpg",
    "/images/packages/oceanview-bay-hotel-2.jpg",
    "/images/packages/oceanview-bay-hotel-3.jpg"
  ],

  rating: 4.6,
  reviews: 987,
  badge: "HOT DEAL",
  description: "Peaceful seafront hotel in Crete with large pool and sunset views.",
  facilities: ["Outdoor Pool","Sea View Rooms","Free Parking","Restaurant","WiFi"]
},


 {
  id: 3,
  name: "Palm Breeze Resort",
  destination: "Antalya",
  country: "Turkey",
  nights: 7,
  boards: [
    { type: "Room Only", price: 199 },
    { type: "Bed & Breakfast", price: 249 },
    { type: "All Inclusive", price: 319 }
  ],

  // Main image
  image: "/images/packages/palm-breeze-resort-1.jpg",

  // Gallery images
  images: [
    "/images/packages/palm-breeze-resort-1.jpg",
    "/images/packages/palm-breeze-resort-2.jpg",
    "/images/packages/palm-breeze-resort-3.jpg"
  ],

  rating: 4.3,
  reviews: 743,
  badge: "BESTSELLER",
  description: "All-round resort in Antalya with pools, private beach and family entertainment.",
  facilities: ["Pool","Private Beach","Restaurant","Kids Club","WiFi"]
},


 {
  id: 4,
  name: "Blue Lagoon Retreat",
  destination: "Malta",
  country: "Malta",
  nights: 5,
  boards: [
    { type: "Room Only", price: 229 },
    { type: "Bed & Breakfast", price: 279 },
    { type: "Half Board", price: 329 }
  ],

  // Main image
  image: "/images/packages/blue-lagoon-retreat-1.jpg",

  // Gallery images
  images: [
    "/images/packages/blue-lagoon-retreat-1.jpg",
    "/images/packages/blue-lagoon-retreat-2.jpg",
    "/images/packages/blue-lagoon-retreat-3.jpg"
  ],

  rating: 4.5,
  reviews: 523,
  badge: "LIMITED OFFER",
  description: "Stylish island resort near Malta’s Blue Lagoon — ideal for couples.",
  facilities: ["Pool","Free Breakfast","Bar","Airport Shuttle"]
},


 {
  id: 5,
  name: "Sunset Paradise Hotel",
  destination: "Phuket",
  country: "Thailand",
  nights: 7,
  boards: [
    { type: "Room Only", price: 279 },
    { type: "Bed & Breakfast", price: 339 },
    { type: "All Inclusive", price: 419 }
  ],

  // Main image
  image: "/images/packages/sunset-paradise-hotel-1.jpg",

  // Gallery images
  images: [
    "/images/packages/sunset-paradise-hotel-1.jpg",
    "/images/packages/sunset-paradise-hotel-2.jpg",
    "/images/packages/sunset-paradise-hotel-3.jpg",
    "/images/packages/sunset-paradise-hotel-4.jpg"
  ],

  rating: 4.8,
  reviews: 2714,
  badge: "PREMIUM PICK",
  description: "Luxury resort in Phuket with infinity pools and direct beach access.",
  facilities: ["Infinity Pool","Spa","Beachfront","Restaurant","Gym"]
},


  {
  id: 6,
  name: "Island Reef Resort",
  destination: "Zanzibar",
  country: "Tanzania",
  nights: 7,
  boards: [
    { type: "Room Only", price: 329 },
    { type: "Bed & Breakfast", price: 389 },
    { type: "All Inclusive", price: 469 }
  ],

  // Main image
  image: "/images/packages/island-reef-resort-1.jpg",

  // Gallery images (4 total)
  images: [
    "/images/packages/island-reef-resort-1.jpg",
    "/images/packages/island-reef-resort-2.jpg",
    "/images/packages/island-reef-resort-3.jpg",
    "/images/packages/island-reef-resort-4.jpg"
  ],

  rating: 4.7,
  reviews: 962,
  badge: "TOP ISLAND DEAL",
  description: "Beautiful beachfront escape with snorkelling and crystal-clear waters.",
  facilities: ["Beachfront","Pool","Spa","Restaurant","Diving Centre"]
},

{
  id: 7,
  name: "Marina View Suites",
  destination: "Dubai Marina",
  country: "UAE",
  nights: 5,
  boards: [
    { type: "Room Only", price: 399 },
    { type: "Bed & Breakfast", price: 459 },
    { type: "All Inclusive", price: 639 }
  ],

  // Main image
  image: "/images/packages/marina-view-suites-1.jpg",

  // Gallery images
  images: [
    "/images/packages/marina-view-suites-1.jpg",
    "/images/packages/marina-view-suites-2.jpg",
    "/images/packages/marina-view-suites-3.jpg",
    "/images/packages/marina-view-suites-4.jpg",
    "/images/packages/marina-view-suites-5.jpg"
  ],

  rating: 4.9,
  reviews: 3164,
  badge: "VIP DEAL",
  description: "Premium suites with marina views, top-class dining and nightlife access.",
  facilities: ["Marina View","Gym","Pool","Restaurant","Bar"]
},


  {
  id: 8,
  name: "Emerald Waters Resort",
  destination: "Mauritius",
  country: "Mauritius",
  nights: 6,
  boards: [
    { type: "Room Only", price: 549 },
    { type: "Bed & Breakfast", price: 629 },
    { type: "Half Board", price: 729 }
  ],

  // Main image
  image: "/images/packages/emerald-waters-resort-1.jpg",

  // Gallery images
  images: [
    "/images/packages/emerald-waters-resort-1.jpg",
    "/images/packages/emerald-waters-resort-2.jpg",
    "/images/packages/emerald-waters-resort-3.jpg",
    "/images/packages/emerald-waters-resort-4.jpg",
    "/images/packages/emerald-waters-resort-5.jpg"
  ],

  rating: 4.8,
  reviews: 1644,
  badge: "HIGH DEMAND",
  description: "Elegant island resort offering lagoon views and world-class dining.",
  facilities: ["Lagoon View","Spa","Private Beach","Watersports","Restaurant"]
},



   {
  id: 10,
  name: "Tropical Garden Suites",
  destination: "Phuket",
  country: "Thailand",
  nights: 7,
  boards: [
    { type: "Bed & Breakfast", price: 349 },
    { type: "Half Board", price: 419 },
    { type: "All Inclusive", price: 499 }
    ],

  // Main image
  image: "/images/packages/tropical-garden-suites-1.jpg",

  // Gallery images
  images: [
    "/images/packages/tropical-garden-suites-1.jpg",
    "/images/packages/tropical-garden-suites-2.jpg",
    "/images/packages/tropical-garden-suites-3.jpg",
    "/images/packages/tropical-garden-suites-4.jpg",
    "/images/packages/tropical-garden-suites-5.jpg"
  ],

  rating: 4.6,
  reviews: 1941,
  badge: "TOP PICK",
  description: "Modern suites surrounded by tropical gardens, offering quiet escapes and pools.",
  facilities: ["Garden View","Spa","Pool","Restaurant","Free WiFi"]
},

 {
  id: 11,
  name: "Aegean Pearl Hotel",
  destination: "Crete",
  country: "Greece",
  nights: 6,
  boards: [
    { type: "Room Only", price: 239 },
    { type: "Bed & Breakfast", price: 279 },
    { type: "Half Board", price: 349 }
  ],

  // Main image
  image: "/images/packages/aegean-pearl-hotel-1.jpg",

  // Gallery images
  images: [
    "/images/packages/aegean-pearl-hotel-1.jpg",
    "/images/packages/aegean-pearl-hotel-2.jpg",
    "/images/packages/aegean-pearl-hotel-3.jpg",
    "/images/packages/aegean-pearl-hotel-4.jpg",
    "/images/packages/aegean-pearl-hotel-5.jpg"
  ],

  rating: 4.4,
  reviews: 1178,
  badge: "BEST VALUE",
  description: "Aegean-style beachfront property with family amenities and authentic dining.",
  facilities: ["Beach Access","Outdoor Pool","Restaurant","Parking","WiFi"]
},


  {
  id: 12,
  name: "Harbour View Resort",
  destination: "Malta",
  country: "Malta",
  nights: 5,
  boards: [
    { type: "Bed & Breakfast", price: 269 },
    { type: "Half Board", price: 329 },
    { type: "All All Inclusive", price: 409 }
  ],

  // Main image
  image: "/images/packages/harbour-view-resort-1.jpg",

  // Gallery images
  images: [
    "/images/packages/harbour-view-resort-1.jpg",
    "/images/packages/harbour-view-resort-2.jpg",
    "/images/packages/harbour-view-resort-3.jpg",
    "/images/packages/harbour-view-resort-4.jpg",
    "/images/packages/harbour-view-resort-5.jpg"
  ],

  rating: 4.3,
  reviews: 889,
  badge: "SPECIAL DEAL",
  description: "Overlooking Malta’s historic harbour with comfortable rooms and rooftop views.",
  facilities: ["Harbour View","Rooftop Pool","Bar","Restaurant","Free WiFi"]
},

  {
  id: 13,
  name: "Royal Palm Resort",
  destination: "Mauritius",
  country: "Mauritius",
  nights: 7,
  boards: [
    { type: "Room Only", price: 599 },
    { type: "Bed & Breakfast", price: 699 },
    { type: "Half Board", price: 799 }
  ],

  // Main image
  image: "/images/packages/royal-palm-resort-1.jpg",

  // Gallery images
  images: [
    "/images/packages/royal-palm-resort-1.jpg",
    "/images/packages/royal-palm-resort-2.jpg",
    "/images/packages/royal-palm-resort-3.jpg",
    "/images/packages/royal-palm-resort-4.jpg",
    "/images/packages/royal-palm-resort-5.jpg"
  ],

  rating: 4.9,
  reviews: 2311,
  badge: "LUXURY DEAL",
  description: "Premium beachfront resort featuring lagoon activities and ocean-view suites.",
  facilities: ["Lagoon View","Private Beach","Spa","Watersports","Fine Dining"]
},


 {
  id: 19,
  name: "Sapphire Coast Resort",
  destination: "Maldives",
  country: "Maldives",
  nights: 7,
  boards: [
    { type: "Room Only", price: 799 },
    { type: "Bed & Breakfast", price: 949 },
    { type: "Half Board", price: 1149 }
  ],

  // Main image
  image: "/images/packages/sapphire-coast-resort-1.jpg",

  // Gallery images
  images: [
    "/images/packages/sapphire-coast-resort-1.jpg",
    "/images/packages/sapphire-coast-resort-2.jpg",
    "/images/packages/sapphire-coast-resort-3.jpg",
    "/images/packages/sapphire-coast-resort-4.jpg",
    "/images/packages/sapphire-coast-resort-5.jpg"
  ],

  rating: 4.9,
  reviews: 2873,
  badge: "LUXURY ESCAPE",
  description: "Premium Maldives resort offering lagoon access and overwater villas.",
  facilities: ["Overwater Villas","Private Beach","Snorkeling Centre","Spa","Infinity Pool"]
},



 {
  id: 23,
  name: "Red Sea Grand Resort",
  destination: "Hurghada",
  country: "Egypt",
  nights: 7,
  boards: [
    { type: "Room Only", price: 289 },
    { type: "All Inclusive", price: 389 }
  ],

  // Main image
  image: "/images/packages/red-sea-grand-resort-1.jpg",

  // Gallery images
  images: [
    "/images/packages/red-sea-grand-resort-1.jpg",
    "/images/packages/red-sea-grand-resort-2.jpg",
    "/images/packages/red-sea-grand-resort-3.jpg",
    "/images/packages/red-sea-grand-resort-4.jpg",
    "/images/packages/red-sea-grand-resort-5.jpg"
  ],

  rating: 4.5,
  reviews: 1331,
  badge: "ALL INCLUSIVE",
  description: "A huge resort with waterpark, private beach and Red Sea coral reefs.",
  facilities: ["Private Beach", "Waterpark", "Pool", "Restaurant", "Spa"]
},


  {
  id: 24,
  name: "Cappadocia Cave Suites",
  destination: "Cappadocia",
  country: "Turkey",
  nights: 4,
  boards: [
    { type: "Room Only", price: 239 },
    { type: "Bed & Breakfast", price: 279 }
  ],

  // Main image
  image: "/images/packages/cappadocia-cave-suites-1.jpg",

  // Gallery images
  images: [
    "/images/packages/cappadocia-cave-suites-1.jpg",
    "/images/packages/cappadocia-cave-suites-2.jpg",
    "/images/packages/cappadocia-cave-suites-3.jpg",
    "/images/packages/cappadocia-cave-suites-4.jpg",
    "/images/packages/cappadocia-cave-suites-5.jpg"
  ],

  rating: 4.7,
  reviews: 978,
  badge: "UNIQUE HOTEL",
  description: "Magical stone cave suites with sunrise hot-air balloon views.",
  facilities: ["Cave Rooms", "Breakfast", "Terrace", "WiFi"]
},


 {
  id: 25,
  name: "Aqua Blue Resort",
  destination: "Sharm El Sheikh",
  country: "Egypt",
  nights: 7,
  boards: [
    { type: "Room Only", price: 259 },
    { type: "All Inclusive", price: 339 }
  ],

  // Main image
  image: "/images/packages/aqua-blue-resort-1.jpg",

  // Gallery images
  images: [
    "/images/packages/aqua-blue-resort-1.jpg",
    "/images/packages/aqua-blue-resort-2.jpg",
    "/images/packages/aqua-blue-resort-3.jpg",
    "/images/packages/aqua-blue-resort-4.jpg",
    "/images/packages/aqua-blue-resort-5.jpg"
  ],

  rating: 4.6,
  reviews: 1456,
  badge: "TOP RED SEA DEAL",
  description: "Lagoon-style pools, slides and premium diving sites nearby.",
  facilities: ["Slides", "Pools", "Beach Access", "Restaurant"]
},




 {
  id: 30,
  name: "Swiss Alps Chalet Resort",
  destination: "Zermatt",
  country: "Switzerland",
  nights: 6,
  boards: [
    { type: "Room Only", price: 499 },
    { type: "Bed & Breakfast", price: 549 },
    { type: "All Inclusive", price: 689 }
  ],

  // Main image
  image: "/images/packages/swiss-alps-chalet-resort-1.jpg",

  // Gallery images
  images: [
    "/images/packages/swiss-alps-chalet-resort-1.jpg",
    "/images/packages/swiss-alps-chalet-resort-2.jpg",
    "/images/packages/swiss-alps-chalet-resort-3.jpg",
    "/images/packages/swiss-alps-chalet-resort-4.jpg",
    "/images/packages/swiss-alps-chalet-resort-5.jpg"
  ],

  rating: 4.9,
  reviews: 1632,
  badge: "MOUNTAIN VIEW",
  description: "Luxury chalets overlooking the Matterhorn with spa facilities.",
  facilities: ["Mountain View", "Spa", "Heated Pool", "Restaurant"]
},


  // ————————————————————————
  // YOU SAID "2 FULL PARTS REMAINING".
  // Here are the rest until Package 40.
  // ————————————————————————

  {
  id: 31,
  name: "Lisbon Bay Hotel",
  destination: "Lisbon",
  country: "Portugal",
  nights: 5,
  boards: [
    { type: "Room Only", price: 249 },
    { type: "Bed & Breakfast", price: 299 },
    { type: "All Inclusive", price: 439 }
  ],

  // Main image
  image: "/images/packages/lisbon-bay-hotel-1.jpg",

  // Gallery images
  images: [
    "/images/packages/lisbon-bay-hotel-1.jpg",
    "/images/packages/lisbon-bay-hotel-2.jpg",
    "/images/packages/lisbon-bay-hotel-3.jpg",
    "/images/packages/lisbon-bay-hotel-4.jpg",
    "/images/packages/lisbon-bay-hotel-5.jpg"
  ],

  rating: 4.5,
  reviews: 933,
  badge: "CITY BREAK",
  description: "Modern hotel near Lisbon’s waterfront with rooftop views.",
  facilities: ["Rooftop", "WiFi", "Bar", "Restaurant"]
},


 {
  id: 32,
  name: "Vienna Imperial Suites",
  destination: "Vienna",
  country: "Austria",
  nights: 4,
  boards: [
    { type: "Room Only", price: 299 },
    { type: "Bed & Breakfast", price: 359 },
    { type: "All Inclusive", price: 499 }
  ],

  // Main image
  image: "/images/packages/vienna-imperial-suites-1.jpg",

  // Gallery images
  images: [
    "/images/packages/vienna-imperial-suites-1.jpg",
    "/images/packages/vienna-imperial-suites-2.jpg",
    "/images/packages/vienna-imperial-suites-3.jpg",
    "/images/packages/vienna-imperial-suites-4.jpg",
    "/images/packages/vienna-imperial-suites-5.jpg"
  ],

  rating: 4.7,
  reviews: 1114,
  badge: "ELEGANT",
  description: "Classic European luxury with palace-style interiors.",
  facilities: ["Restaurant", "Bar", "WiFi"]
},


  {
  id: 33,
  name: "Swiss Lake Resort",
  destination: "Lake Lucerne",
  country: "Switzerland",
  nights: 5,
  boards: [
    { type: "Room Only", price: 349 },
    { type: "Bed & Breakfast", price: 399 },
    { type: "All Inclusive", price: 539 }
  ],

  // Main image
  image: "/images/packages/swiss-lake-resort-1.jpg",

  // Gallery images
  images: [
    "/images/packages/swiss-lake-resort-1.jpg",
    "/images/packages/swiss-lake-resort-2.jpg",
    "/images/packages/swiss-lake-resort-3.jpg",
    "/images/packages/swiss-lake-resort-4.jpg",
    "/images/packages/swiss-lake-resort-5.jpg"
  ],

  rating: 4.8,
  reviews: 1543,
  badge: "LAKE VIEW",
  description: "Peaceful lakeside escape surrounded by the Alps.",
  facilities: ["Lake View", "Spa", "Restaurant", "Terrace"]
},


  {
  id: 34,
  name: "Berlin Central Hotel",
  destination: "Berlin",
  country: "Germany",
  nights: 4,
  boards: [
    { type: "Room Only", price: 219 },
    { type: "Bed & Breakfast", price: 259 },
     { type: "All Inclusive", price: 399 }
  ],

  // Main image
  image: "/images/packages/berlin-central-hotel-1.jpg",

  // Gallery images
  images: [
    "/images/packages/berlin-central-hotel-1.jpg",
    "/images/packages/berlin-central-hotel-2.jpg",
    "/images/packages/berlin-central-hotel-3.jpg",
    "/images/packages/berlin-central-hotel-4.jpg",
    "/images/packages/berlin-central-hotel-5.jpg"
  ],

  rating: 4.4,
  reviews: 864,
  badge: "CITY HOTEL",
  description: "Central Berlin hotel close to all major attractions.",
  facilities: ["WiFi", "Breakfast", "Metro Access"]
},


  {
  id: 35,
  name: "Prague Castle Suites",
  destination: "Prague",
  country: "Czech Republic",
  nights: 4,
  boards: [
    { type: "Room Only", price: 229 },
    { type: "Bed & Breakfast", price: 289 },
    { type: "All Inclusive", price: 429 }
  ],

  // Main image
  image: "/images/packages/prague-castle-suites-1.jpg",

  // Gallery images
  images: [
    "/images/packages/prague-castle-suites-1.jpg",
    "/images/packages/prague-castle-suites-2.jpg",
    "/images/packages/prague-castle-suites-3.jpg",
    "/images/packages/prague-castle-suites-4.jpg",
    "/images/packages/prague-castle-suites-5.jpg"
  ],

  rating: 4.6,
  reviews: 1194,
  badge: "OLD TOWN",
  description: "Historic suites in the beautiful Prague old town.",
  facilities: ["Historic Area", "WiFi", "Breakfast"]
},



 {
  id: 39,
  name: "Vienna Lake Suites",
  destination: "Hallstatt",
  country: "Austria",
  nights: 5,

  boards: [
    { type: "Room Only", price: 329 },
    { type: "Bed & Breakfast", price: 379 },
    { type: "All Inclusive", price: 519 }
  ],

  image: "/images/packages/vienna-lake-suites-1.jpg",

  images: [
    "/images/packages/vienna-lake-suites-1.jpg",
    "/images/packages/vienna-lake-suites-2.jpg",
    "/images/packages/vienna-lake-suites-3.jpg",
    "/images/packages/vienna-lake-suites-4.jpg",
    "/images/packages/vienna-lake-suites-5.jpg"
  ],

  rating: 4.9,
  reviews: 1688,
  badge: "SCENIC",

  description: "One of the world’s most scenic lakeside destinations.",

  facilities: ["Lake View", "Breakfast", "Terrace"]
},

  
  
   
  // Add these 20 European packages (ids 41 - 60) to your src/data/packages.js
 
{
  id: 41,
  name: "Costa Blanca Seaside Hotel",
  destination: "Alicante, Spain",
  country: "Spain",
  nights: 7,
  boards: [
    { type: "Bed & Breakfast", price: 139 },
    { type: "Half Board", price: 349 },
    { type: "All Inclusive", price: 429 }
  ],

  // Thumbnail main image
  image: "/images/packages/costa-blanca-seaside-hotel-1.jpg",

  // Gallery images
  images: [
    "/images/packages/costa-blanca-seaside-hotel-1.jpg",
    "/images/packages/costa-blanca-seaside-hotel-2.jpg",
    "/images/packages/costa-blanca-seaside-hotel-3.jpg"
  ],

  rating: 4.3,
  reviews: 421,
  badge: "SUN & SAND",
  description: "Comfortable beachfront hotel with family-friendly facilities and close to Alicante marina.",
  facilities: ["Beach Access", "Pool", "Restaurant", "WiFi"]
},



  {
  id: 43,
  name: "Portuguese Coast Hideaway",
  destination: "Algarve, Portugal",
  country: "Portugal",
  nights: 7,
  boards: [
      { type: "Bed & Breakfast", price: 219 },
      { type: "Breakfast", price: 269 },
      { type: "All Inclusive", price: 329 }
  ],

  // Main image
  image: "/images/packages/portuguese-coast-hideaway-1.jpg",

  // Gallery images
  images: [
    "/images/packages/portuguese-coast-hideaway-1.jpg",
    "/images/packages/portuguese-coast-hideaway-2.jpg",
    "/images/packages/portuguese-coast-hideaway-3.jpg",
    "/images/packages/portuguese-coast-hideaway-4.jpg",
    "/images/packages/portuguese-coast-hideaway-5.jpg"
  ],

  rating: 4.2,
  reviews: 205,
  badge: "COASTAL STAY",
  description: "Charming hideaway close to the cliffs and golden beaches of the Algarve coast.",
  facilities: ["Beach Nearby", "Pool", "Parking", "WiFi"]
},


  {
  id: 44,
  name: "Sardinia Blue Villas",
  destination: "Sardinia, Italy",
  country: "Italy",
  nights: 6,
  boards: [
    { type: "Bed & Breakfast", price: 159 },
    { type: "Half Board", price: 289 },
    { type: "All Inclusive", price: 469 }
  ],

  // Main image
  image: "/images/packages/sardinia-blue-villas-1.jpg",

  // Gallery images
  images: [
    "/images/packages/sardinia-blue-villas-1.jpg",
    "/images/packages/sardinia-blue-villas-2.jpg",
    "/images/packages/sardinia-blue-villas-3.jpg",
    "/images/packages/sardinia-blue-villas-4.jpg",
    "/images/packages/sardinia-blue-villas-5.jpg"
  ],

  rating: 4.5,
  reviews: 289,
  badge: "VILLA DEAL",
  description: "Private villas with terraces and sea views on Sardinia’s unspoilt coastline.",
  facilities: ["Private Pool", "Terrace", "BBQ", "WiFi"]
},

 {
  id: 45,
  name: "Nice Riviera Boutique Hotel",
  destination: "Nice, French Riviera",
  country: "France",
  nights: 5,
  boards: [
    { type: "Breakfast", price: 319 },
    { type: "Half Board", price: 389 },
    { type: "All Inclusive", price: 469 }
  ],

  // Main image
  image: "/images/packages/nice-riviera-boutique-hotel-1.jpg",

  // Gallery images
  images: [
    "/images/packages/nice-riviera-boutique-hotel-1.jpg",
    "/images/packages/nice-riviera-boutique-hotel-2.jpg",
    "/images/packages/nice-riviera-boutique-hotel-3.jpg",
    "/images/packages/nice-riviera-boutique-hotel-4.jpg", // from local uploaded file
    "/images/packages/nice-riviera-boutique-hotel-5.jpg"
  ],

  rating: 4.6,
  reviews: 512,
  badge: "RIVIERA CLASSIC",
  description: "Stylish boutique hotel a short stroll from the Promenade des Anglais and vibrant cafés.",
  facilities: ["City Centre", "Breakfast", "Rooftop Bar", "WiFi"]
},


 {
  id: 47,
  name: "Mallorca Family Resort",
  destination: "Mallorca, Balearics",
  country: "Spain",
  nights: 7,
  boards: [
    { type: "Bed & Breakfast", price: 329 },
    { type: "Half Board", price: 389 },
    { type: "All Inclusive", price: 469 }
  ],

  // Main image
  image: "/images/packages/mallorca-family-resort-1.jpg",

  // Gallery images
  images: [
    "/images/packages/mallorca-family-resort-1.jpg",
    "/images/packages/mallorca-family-resort-2.jpg",
    "/images/packages/mallorca-family-resort-3.jpg",
    "/images/packages/mallorca-family-resort-4.jpg",
    "/images/packages/mallorca-family-resort-5.jpg"
  ],

  rating: 4.2,
  reviews: 612,
  badge: "FAMILY FUN",
  description: "Large family-friendly resort near shallow sandy beaches and water-park facilities.",
  facilities: ["Kids Club", "Pools", "Entertainment", "Restaurant"]
},

 {
  id: 51,
  name: "Santorini Sunset Suites",
  destination: "Santorini, Greece",
  country: "Greece",
  nights: 5,
  boards: [
    { type: "Breakfast", price: 379 },
    { type: "Half Board", price: 449 },
    { type: "All Inclusive", price: 599 }
  ],

  // Main image
  image: "/images/packages/santorini-sunset-suites-1.jpg",

  // Gallery images
  images: [
    "/images/packages/santorini-sunset-suites-1.jpg",
    "/images/packages/santorini-sunset-suites-2.jpg",
    "/images/packages/santorini-sunset-suites-3.jpg",
    "/images/packages/santorini-sunset-suites-4.jpg",
    "/images/packages/santorini-sunset-suites-5.jpg"
  ],

  rating: 4.8,
  reviews: 823,
  badge: "SUNSET VIEWS",
  description: "Iconic Santorini terraces with stunning caldera sunsets and premium dining options.",
  facilities: ["Terrace", "Sea Views", "Breakfast", "Spa"]
},


  {
  id: 52,
  name: "Lisbon City & Coast Break",
  destination: "Lisbon, Portugal",
  country: "Portugal",
  nights: 3,

  boards: [
    { type: "Breakfast", price: 189 },
    { type: "Half Board", price: 239 },
    { type: "All Inclusive", price: 399 }
  ],

  image: "/images/packages/lisbon-city-coast-break-1.jpg",

  images: [
    "/images/packages/lisbon-city-coast-break-1.jpg",
    "/images/packages/lisbon-city-coast-break-2.jpg",
    "/images/packages/lisbon-city-coast-break-3.jpg",
    "/images/packages/lisbon-city-coast-break-4.jpg",
    "/images/packages/lisbon-city-coast-break-5.jpg"
  ],

  rating: 4.2,
  reviews: 342,
  badge: "CITY + COAST",

  description:
    "Short city break with optional coastal day trips and surf experiences on Cascais beaches.",

  facilities: ["City Tours", "Breakfast", "Transport Options", "WiFi"]
},


 {
  id: 54,
  name: "Kefalonia Cliff Resort",
  destination: "Kefalonia, Greece",
  country: "Greece",
  nights: 7,
  boards: [
    { type: "Bed & Breakfast", price: 329 },
    { type: "Half Board", price: 389 },
    { type: "All Inclusive", price: 469 }
  ],

  // Local main image
  image: "/images/packages/kefalonia-cliff-resort-1.jpg",

  images: [
    "/images/packages/kefalonia-cliff-resort-1.jpg",
    "/images/packages/kefalonia-cliff-resort-2.jpg",
    "/images/packages/kefalonia-cliff-resort-3.jpg",
    "/images/packages/kefalonia-cliff-resort-4.jpg",
    "/images/packages/kefalonia-cliff-resort-5.jpg"
  ],

  rating: 4.4,
  reviews: 251,
  badge: "COASTAL RETREAT",
  description: "Peaceful cliffside resort with private terraces and views across Kefalonia’s bays.",
  facilities: ["Terraces", "Pool", "Spa", "WiFi"]
},

 

  {
  id: 56,
  name: "Madeira Cliff Retreat",
  destination: "Madeira, Portugal",
  country: "Portugal",
  nights: 7,
  boards: [
    { type: "Bed & Breakfast", price: 329 },
    { type: "Half Board", price: 389 },
    { type: "All Inclusive", price: 469 }
  ],

  image: "/images/packages/madeira-cliff-retreat-1.jpg",

  images: [
    "/images/packages/madeira-cliff-retreat-1.jpg",
    "/images/packages/madeira-cliff-retreat-2.jpg",
    "/images/packages/madeira-cliff-retreat-3.jpg",
    "/images/packages/madeira-cliff-retreat-4.jpg",
    "/images/packages/madeira-cliff-retreat-5.jpg"
  ],

  rating: 4.5,
  reviews: 198,
  badge: "NATURAL WONDERS",
  description: "Clifftop accommodation with dramatic Atlantic views and walking access to natural pools.",
  facilities: ["Hiking Access", "Pool", "Breakfast", "Tours"]
},



  {
  id: 60,
  name: "Canary Islands Surf & Sun",
  destination: "Fuerteventura, Canary Islands",
  country: "Spain",
  nights: 7,
  boards: [
    { type: "Bed & Breakfast", price: 329 },
    { type: "Half Board", price: 389 },
    { type: "All Inclusive", price: 469 }
  ],

  image: "/images/packages/canary-islands-surf-sun-1.jpg",

  images: [
    "/images/packages/canary-islands-surf-sun-1.jpg",
    "/images/packages/canary-islands-surf-sun-2.jpg",
    "/images/packages/canary-islands-surf-sun-3.jpg",
    "/images/packages/canary-islands-surf-sun-4.jpg",
    "/images/packages/canary-islands-surf-sun-5.jpg"
  ],

  rating: 4.3,
  reviews: 381,
  badge: "SURF & SUN",
  description: "Wind-swept beaches ideal for watersports and relaxing stays—with year-round sunshine.",
  facilities: ["Watersports", "Pool", "Self Catering", "WiFi"]
},


  // src/data/packages.js
// Packages 1–60 (international – no India). All hotels: B&B, Half Board, All Inclusive.


  {
  id: 1,
  name: "Coral Beach Resort",
  destination: "Costa del Sol",
  country: "Spain",
  nights: 7,

  boards: [
    { type: "Bed & Breakfast", price: 299 },
    { type: "Half Board", price: 359 },
    { type: "All Inclusive", price: 439 }
  ],

  image: "/images/packages/coral-beach-resort-1.jpg",

  images: [
    "/images/packages/coral-beach-resort-1.jpg",
    "/images/packages/coral-beach-resort-2.jpg",
    "/images/packages/coral-beach-resort-3.jpg",
    "/images/packages/coral-beach-resort-4.jpg",
    "/images/packages/coral-beach-resort-5.jpg"
  ],

  rating: 4.4,
  reviews: 1244,
  badge: "FREE BREAKFAST",

  description:
    "Beachfront hotel in Costa del Sol with modern rooms and easy access to the promenade.",

  facilities: [
    "Swimming Pool",
    "Beachfront Access",
    "Restaurant",
    "Free WiFi",
    "Bar"
  ]
},


   {
  id: 8,
  name: "Emerald Waters Resort",
  destination: "Mauritius",
  country: "Mauritius",
  nights: 6,
  boards: [
    { type: "Room Only", price: 549 },
    { type: "Bed & Breakfast", price: 629 },
    { type: "Half Board", price: 729 }
  ],

  // Main image
  image: "/images/packages/emerald-waters-resort-1.jpg",

  // Gallery images
  images: [
    "/images/packages/emerald-waters-resort-1.jpg",
    "/images/packages/emerald-waters-resort-2.jpg",
    "/images/packages/emerald-waters-resort-3.jpg",
    "/images/packages/emerald-waters-resort-4.jpg",
    "/images/packages/emerald-waters-resort-5.jpg"
  ],

  rating: 4.8,
  reviews: 1644,
  badge: "HIGH DEMAND",
  description: "Elegant island resort offering lagoon views and world-class dining.",
  facilities: ["Lagoon View","Spa","Private Beach","Watersports","Restaurant"]
},

  {
  id: 9,
  name: "Coral Reef Villas",
  destination: "Bali",
  country: "Indonesia",
  nights: 6,
  boards: [
    { type: "Bed & Breakfast", price: 319 },
    { type: "Half Board", price: 389 },
    { type: "All Inclusive", price: 469 }
  ],

  // Main image
  image: "/images/packages/coral-reef-villas-1.jpg",

  // Gallery images
  images: [
    "/images/packages/coral-reef-villas-1.jpg",
    "/images/packages/coral-reef-villas-2.jpg",
    "/images/packages/coral-reef-villas-3.jpg",
    "/images/packages/coral-reef-villas-4.jpg",
    "/images/packages/coral-reef-villas-5.jpg"
  ],

  rating: 4.7,
  reviews: 1477,
  badge: "VILLA DEAL",
  description: "Private villas with pools surrounded by tropical gardens in Bali.",
  facilities: ["Private Pool","Garden View","Spa","Restaurant"]
},


  {
  id: 10,
  name: "Tropical Garden Suites",
  destination: "Phuket",
  country: "Thailand",
  nights: 7,
  boards: [
    { type: "Bed & Breakfast", price: 349 },
    { type: "Half Board", price: 419 },
    { type: "All Inclusive", price: 499 }
    ],

  // Main image
  image: "/images/packages/tropical-garden-suites-1.jpg",

  // Gallery images
  images: [
    "/images/packages/tropical-garden-suites-1.jpg",
    "/images/packages/tropical-garden-suites-2.jpg",
    "/images/packages/tropical-garden-suites-3.jpg",
    "/images/packages/tropical-garden-suites-4.jpg",
    "/images/packages/tropical-garden-suites-5.jpg"
  ],

  rating: 4.6,
  reviews: 1941,
  badge: "TOP PICK",
  description: "Modern suites surrounded by tropical gardens, offering quiet escapes and pools.",
  facilities: ["Garden View","Spa","Pool","Restaurant","Free WiFi"]
},


  {
  id: 11,
  name: "Aegean Pearl Hotel",
  destination: "Crete",
  country: "Greece",
  nights: 6,
  boards: [
    { type: "Room Only", price: 239 },
    { type: "Bed & Breakfast", price: 279 },
    { type: "Half Board", price: 349 }
  ],

  // Main image
  image: "/images/packages/aegean-pearl-hotel-1.jpg",

  // Gallery images
  images: [
    "/images/packages/aegean-pearl-hotel-1.jpg",
    "/images/packages/aegean-pearl-hotel-2.jpg",
    "/images/packages/aegean-pearl-hotel-3.jpg",
    "/images/packages/aegean-pearl-hotel-4.jpg",
    "/images/packages/aegean-pearl-hotel-5.jpg"
  ],

  rating: 4.4,
  reviews: 1178,
  badge: "BEST VALUE",
  description: "Aegean-style beachfront property with family amenities and authentic dining.",
  facilities: ["Beach Access","Outdoor Pool","Restaurant","Parking","WiFi"]
},

 {
  id: 12,
  name: "Harbour View Resort",
  destination: "Malta",
  country: "Malta",
  nights: 5,
  boards: [
    { type: "Bed & Breakfast", price: 269 },
    { type: "Half Board", price: 329 },
    { type: "All All Inclusive", price: 409 }
  ],

  // Main image
  image: "/images/packages/harbour-view-resort-1.jpg",

  // Gallery images
  images: [
    "/images/packages/harbour-view-resort-1.jpg",
    "/images/packages/harbour-view-resort-2.jpg",
    "/images/packages/harbour-view-resort-3.jpg",
    "/images/packages/harbour-view-resort-4.jpg",
    "/images/packages/harbour-view-resort-5.jpg"
  ],

  rating: 4.3,
  reviews: 889,
  badge: "SPECIAL DEAL",
  description: "Overlooking Malta’s historic harbour with comfortable rooms and rooftop views.",
  facilities: ["Harbour View","Rooftop Pool","Bar","Restaurant","Free WiFi"]
},


  {
  id: 13,
  name: "Royal Palm Resort",
  destination: "Mauritius",
  country: "Mauritius",
  nights: 7,
  boards: [
    { type: "Room Only", price: 599 },
    { type: "Bed & Breakfast", price: 699 },
    { type: "Half Board", price: 799 }
  ],

  // Main image
  image: "/images/packages/royal-palm-resort-1.jpg",

  // Gallery images
  images: [
    "/images/packages/royal-palm-resort-1.jpg",
    "/images/packages/royal-palm-resort-2.jpg",
    "/images/packages/royal-palm-resort-3.jpg",
    "/images/packages/royal-palm-resort-4.jpg",
    "/images/packages/royal-palm-resort-5.jpg"
  ],

  rating: 4.9,
  reviews: 2311,
  badge: "LUXURY DEAL",
  description: "Premium beachfront resort featuring lagoon activities and ocean-view suites.",
  facilities: ["Lagoon View","Private Beach","Spa","Watersports","Fine Dining"]
},

  {
  id: 14,
  name: "Zen Hills Retreat",
  destination: "Bali",
  country: "Indonesia",
  nights: 6,
  boards: [
    { type: "Bed & Breakfast", price: 329 },
    { type: "Half Board", price: 389 },
    { type: "All Inclusive", price: 469 }
  ],

  // Main image
  image: "/images/packages/zen-hills-retreat-1.jpg",

  // Gallery images
  images: [
    "/images/packages/zen-hills-retreat-1.jpg",
    "/images/packages/zen-hills-retreat-2.jpg",
    "/images/packages/zen-hills-retreat-3.jpg",
    "/images/packages/zen-hills-retreat-4.jpg",
    "/images/packages/zen-hills-retreat-5.jpg"
  ],

  rating: 4.6,
  reviews: 1764,
  badge: "POPULAR",
  description: "Hillside villas offering serene views and private relaxation areas in Bali.",
  facilities: ["Private Villas","Spa","Restaurant","Infinity Pool"]
},


 {
  id: 15,
  name: "Sunset Harbour Suites",
  destination: "Dubai Marina",
  country: "UAE",
  nights: 5,
  boards: [
    { type: "Bed & Breakfast", price: 499 },
    { type: "Half Board", price: 579 },
    { type: "All Inclusive", price: 659 }
  ],

  // Main image
  image: "/images/packages/sunset-harbour-suites-1.jpg",

  // Gallery images
  images: [
    "/images/packages/sunset-harbour-suites-1.jpg",
    "/images/packages/sunset-harbour-suites-2.jpg",
    "/images/packages/sunset-harbour-suites-3.jpg",
    "/images/packages/sunset-harbour-suites-4.jpg",
    "/images/packages/sunset-harbour-suites-5.jpg"
  ],

  rating: 4.7,
  reviews: 1984,
  badge: "PREMIUM SUITE",
  description: "Exclusive marina-side suites with modern interiors and city access.",
  facilities: ["Marina View","Gym","Pool","Restaurant","Shuttle Service"]
},


 {
  id: 16,
  name: "Blue Coast Escape",
  destination: "Costa del Sol",
  country: "Spain",
  nights: 7,
  boards: [
    { type: "Bed & Breakfast", price: 319 },
    { type: "Half Board", price: 389 },
    { type: "All Inclusive", price: 469 }
  ],

  // Main image
  image: "/images/packages/blue-coast-escape-1.jpg",

  // Gallery images
  images: [
    "/images/packages/blue-coast-escape-1.jpg",
    "/images/packages/blue-coast-escape-2.jpg",
    "/images/packages/blue-coast-escape-3.jpg",
    "/images/packages/blue-coast-escape-4.jpg",
    "/images/packages/blue-coast-escape-5.jpg"
  ],

  rating: 4.5,
  reviews: 1433,
  badge: "COUPLE DEAL",
  description: "Perfect for couples — ocean views, quiet pools and stylish lounges.",
  facilities: ["Beachfront","Pool","Restaurant","Bar","WiFi"]
},


  {
  id: 17,
  name: "Island Horizon Resort",
  destination: "Zanzibar",
  country: "Tanzania",
  nights: 7,
  boards: [
    { type: "Bed & Breakfast", price: 419 },
    { type: "Half Board", price: 499 },
    { type: "All Inclusive", price: 579 }
  ],

  // Main image
  image: "/images/packages/island-horizon-resort-1.jpg",

  // Gallery images
  images: [
    "/images/packages/island-horizon-resort-1.jpg",
    "/images/packages/island-horizon-resort-2.jpg",
    "/images/packages/island-horizon-resort-3.jpg",
    "/images/packages/island-horizon-resort-4.jpg",
    "/images/packages/island-horizon-resort-5.jpg"
  ],

  rating: 4.8,
  reviews: 1121,
  badge: "ISLAND DEAL",
  description: "Eco-friendly resort offering diving, reefs and panoramic ocean views.",
  facilities: ["Diving Centre","Beachfront","Spa","Restaurant"]
},


  {
  id: 18,
  name: "Sunrise Pearl Villas",
  destination: "Phuket",
  country: "Thailand",
  nights: 6,
  boards: [
    { type: "Bed & Breakfast", price: 369 },
    { type: "Half Board", price: 449 },
    { type: "All Inclusive", price: 529 }
  ],

  // Main image
  image: "/images/packages/sunrise-pearl-villas-1.jpg",

  // Gallery images
  images: [
    "/images/packages/sunrise-pearl-villas-1.jpg",
    "/images/packages/sunrise-pearl-villas-2.jpg",
    "/images/packages/sunrise-pearl-villas-3.jpg",
    "/images/packages/sunrise-pearl-villas-4.jpg",
    "/images/packages/sunrise-pearl-villas-5.jpg"
  ],

  rating: 4.7,
  reviews: 1299,
  badge: "VILLA OFFER",
  description: "Luxury private villas with private pools and modern tropical interiors.",
  facilities: ["Private Pool","Spa","Restaurant","Gym"]
},



 {
  id: 20,
  name: "Golden Palm Retreat",
  destination: "Dubai",
  country: "UAE",
  nights: 5,
  boards: [
    { type: "Bed & Breakfast", price: 529 },
    { type: "Half Board", price: 599 },
    { type: "All Inclusive", price: 679 }
  ],

  // Main image
  image: "/images/packages/golden-palm-retreat-1.jpg",

  // Gallery images
  images: [
    "/images/packages/golden-palm-retreat-1.jpg",
    "/images/packages/golden-palm-retreat-2.jpg",
    "/images/packages/golden-palm-retreat-3.jpg",
    "/images/packages/golden-palm-retreat-4.jpg",
    "/images/packages/golden-palm-retreat-5.jpg"
  ],

  rating: 4.7,
  reviews: 1985,
  badge: "PREMIUM PICK",
  description: "Modern luxury retreat near Dubai Marina with fine dining and skyline views.",
  facilities: ["Marina View","Rooftop Pool","Spa","Gym","Restaurant"]
},

 {
  id: 21,
  name: "Azure Coast Hotel",
  destination: "Costa Brava",
  country: "Spain",
  nights: 7,
  boards: [
    { type: "Bed & Breakfast", price: 299 },
    { type: "Half Board", price: 359 },
    { type: "All Inclusive", price: 439 }
  ],

  // Main image
  image: "/images/packages/azure-coast-hotel-1.jpg",

  // Gallery images
  images: [
    "/images/packages/azure-coast-hotel-1.jpg",
    "/images/packages/azure-coast-hotel-2.jpg",
    "/images/packages/azure-coast-hotel-3.jpg",
    "/images/packages/azure-coast-hotel-4.jpg",
    "/images/packages/azure-coast-hotel-5.jpg"
  ],

  rating: 4.4,
  reviews: 1221,
  badge: "POPULAR",
  description: "Mediterranean beachfront hotel with sea view rooms.",
  facilities: ["Beachfront", "Pool", "Restaurant", "Bar", "Free WiFi"]
},


  {
  id: 22,
  name: "Santorini Cliff Suites",
  destination: "Santorini",
  country: "Greece",
  nights: 5,
  boards: [
    { type: "Bed & Breakfast", price: 459 },
    { type: "Half Board", price: 519 },
    { type: "All Inclusive", price: 599 }
  ],

  // Main image
  image: "/images/packages/santorini-cliff-suites-1.jpg",

  // Gallery images
  images: [
    "/images/packages/santorini-cliff-suites-1.jpg",
    "/images/packages/santorini-cliff-suites-2.jpg",
    "/images/packages/santorini-cliff-suites-3.jpg",
    "/images/packages/santorini-cliff-suites-4.jpg",
    "/images/packages/santorini-cliff-suites-5.jpg"
  ],

  rating: 4.9,
  reviews: 2111,
  badge: "SIGNATURE",
  description: "Cliffside suites with infinity pools and Caldera views.",
  facilities: ["Infinity Pool", "Sea View", "Private Terrace", "Breakfast"]
},




 {
  id: 26,
  name: "Amalfi View Hotel",
  destination: "Amalfi Coast",
  country: "Italy",
  nights: 5,
  boards: [
    { type: "Bed & Breakfast", price: 429 },
    { type: "Half Board", price: 489 },
    { type: "All Inclusive", price: 569 }
  ],

  // Main image
  image: "/images/packages/amalfi-view-hotel-1.jpg",

  // Gallery images
  images: [
    "/images/packages/amalfi-view-hotel-1.jpg",
    "/images/packages/amalfi-view-hotel-2.jpg",
    "/images/packages/amalfi-view-hotel-3.jpg",
    "/images/packages/amalfi-view-hotel-4.jpg",
    "/images/packages/amalfi-view-hotel-5.jpg"
  ],

  rating: 4.8,
  reviews: 1883,
  badge: "SEA VIEW",
  description: "Breathtaking cliffside ocean views along the Italian Riviera.",
  facilities: ["Sea View", "Terrace", "Breakfast", "WiFi"]
},

  {
  id: 27,
  name: "Paris City Retreat",
  destination: "Paris",
  country: "France",
  nights: 4,
  boards: [
    { type: "Bed & Breakfast", price: 349 },
    { type: "Half Board", price: 409 },
    { type: "All Inclusive", price: 489 }
  ],

  // Main image
  image: "/images/packages/paris-city-retreat-1.jpg",

  // Gallery images
  images: [
    "/images/packages/paris-city-retreat-1.jpg",
    "/images/packages/paris-city-retreat-2.jpg",
    "/images/packages/paris-city-retreat-3.jpg",
    "/images/packages/paris-city-retreat-4.jpg",
    "/images/packages/paris-city-retreat-5.jpg"
  ],

  rating: 4.5,
  reviews: 964,
  badge: "CITY BREAK",
  description: "Elegant boutique hotel in central Paris near major attractions.",
  facilities: ["City Centre", "WiFi", "Breakfast", "Metro Access"]
},


  {
  id: 28,
  name: "Rome Imperial Hotel",
  destination: "Rome",
  country: "Italy",
  nights: 4,
  boards: [
    { type: "Bed & Breakfast", price: 329 },
    { type: "Half Board", price: 389 },
    { type: "All Inclusive", price: 469 }
  ],

  // Main image
  image: "/images/packages/rome-imperial-hotel-1.jpg",

  // Gallery images
  images: [
    "/images/packages/rome-imperial-hotel-1.jpg",
    "/images/packages/rome-imperial-hotel-2.jpg",
    "/images/packages/rome-imperial-hotel-3.jpg",
    "/images/packages/rome-imperial-hotel-4.jpg",
    "/images/packages/rome-imperial-hotel-5.jpg"
  ],

  rating: 4.6,
  reviews: 1104,
  badge: "HISTORIC AREA",
  description: "Stay near the Colosseum with classic European-style interiors.",
  facilities: ["Central Location", "Breakfast", "WiFi"]
},

 {
  id: 29,
  name: "Amsterdam Canal Suites",
  destination: "Amsterdam",
  country: "Netherlands",
  nights: 4,
  boards: [
    { type: "Bed & Breakfast", price: 369 },
    { type: "Half Board", price: 429 },
    { type: "All Inclusive", price: 509 }
  ],

  // Main image
  image: "/images/packages/amsterdam-canal-suites-1.jpg",

  // Gallery images
  images: [
    "/images/packages/amsterdam-canal-suites-1.jpg",
    "/images/packages/amsterdam-canal-suites-2.jpg",
    "/images/packages/amsterdam-canal-suites-3.jpg",
    "/images/packages/amsterdam-canal-suites-4.jpg",
    "/images/packages/amsterdam-canal-suites-5.jpg"
  ],

  rating: 4.7,
  reviews: 1432,
  badge: "CANAL VIEW",
  description: "Beautiful rooms along Amsterdam’s iconic canal district.",
  facilities: ["Canal View", "WiFi", "Breakfast", "Bicycle Rental"]
},


  // ————————————————————————
  // Here are the rest until Package 40.
  // ————————————————————————

  {
  id: 31,
  name: "Lisbon Bay Hotel",
  destination: "Lisbon",
  country: "Portugal",
  nights: 5,
  boards: [
    { type: "Room Only", price: 249 },
    { type: "Bed & Breakfast", price: 299 },
    { type: "All Inclusive", price: 439 }
  ],

  // Main image
  image: "/images/packages/lisbon-bay-hotel-1.jpg",

  // Gallery images
  images: [
    "/images/packages/lisbon-bay-hotel-1.jpg",
    "/images/packages/lisbon-bay-hotel-2.jpg",
    "/images/packages/lisbon-bay-hotel-3.jpg",
    "/images/packages/lisbon-bay-hotel-4.jpg",
    "/images/packages/lisbon-bay-hotel-5.jpg"
  ],

  rating: 4.5,
  reviews: 933,
  badge: "CITY BREAK",
  description: "Modern hotel near Lisbon’s waterfront with rooftop views.",
  facilities: ["Rooftop", "WiFi", "Bar", "Restaurant"]
},


  

  {
  id: 36,
  name: "Croatia Riviera Resort",
  destination: "Dubrovnik",
  country: "Croatia",
  nights: 6,
  boards: [
    { type: "Bed & Breakfast", price: 339 },
    { type: "Half Board", price: 399 },
    { type: "All Inclusive", price: 479 }
  ],

  // Main image
  image: "/images/packages/croatia-riviera-resort-1.jpg",

  // Gallery images
  images: [
    "/images/packages/croatia-riviera-resort-1.jpg",
    "/images/packages/croatia-riviera-resort-2.jpg",
    "/images/packages/croatia-riviera-resort-3.jpg",
    "/images/packages/croatia-riviera-resort-4.jpg",
    "/images/packages/croatia-riviera-resort-5.jpg"
  ],

  rating: 4.7,
  reviews: 1312,
  badge: "SEAFRONT",
  description: "Stunning Adriatic coastline resort with crystal waters.",
  facilities: ["Seafront", "Pool", "Dining", "Spa"]
},


  {
  id: 37,
  name: "Cyprus Golden Sands",
  destination: "Ayia Napa",
  country: "Cyprus",
  nights: 7,
  boards: [
    { type: "Bed & Breakfast", price: 319 },
    { type: "Half Board", price: 379 },
    { type: "All Inclusive", price: 459 }
  ],

  // Main image
  image: "/images/packages/cyprus-golden-sands-1.jpg",

  // Gallery images
  images: [
    "/images/packages/cyprus-golden-sands-1.jpg",
    "/images/packages/cyprus-golden-sands-2.jpg",
    "/images/packages/cyprus-golden-sands-3.jpg",
    "/images/packages/cyprus-golden-sands-4.jpg",
    "/images/packages/cyprus-golden-sands-5.jpg"
  ],

  rating: 4.5,
  reviews: 984,
  badge: "BEACH DEAL",
  description: "Soft sandy beaches, blue waters and party nightlife.",
  facilities: ["Beachfront", "Pool", "WiFi", "Bar"]
},


  {
  id: 38,
  name: "Madeira Ocean Resort",
  destination: "Madeira",
  country: "Portugal",
  nights: 6,
  boards: [
    { type: "Bed & Breakfast", price: 349 },
    { type: "Half Board", price: 409 },
    { type: "All Inclusive", price: 489 }
  ],

  image: "/images/packages/madeira-ocean-resort-1.jpg",

  images: [
    "/images/packages/madeira-ocean-resort-1.jpg",
    "/images/packages/madeira-ocean-resort-2.jpg",
    "/images/packages/madeira-ocean-resort-3.jpg",
    "/images/packages/madeira-ocean-resort-4.jpg",
    "/images/packages/madeira-ocean-resort-5.jpg"
  ],

  rating: 4.6,
  reviews: 1103,
  badge: "NATURE ESCAPE",
  description: "Lush island landscapes with ocean cliffs and beautiful trails.",
  facilities: ["Ocean View", "Trails", "Restaurant", "Pool"]
},

 {
  id: 40,
  name: "Reykjavik Northern Lights Hotel",
  destination: "Reykjavik",
  country: "Iceland",
  nights: 5,
  boards: [
    { type: "Bed & Breakfast", price: 419 },
    { type: "Half Board", price: 479 },
    { type: "All Inclusive", price: 559 }
  ],

  // Main image
  image: "/images/packages/reykjavik-northern-lights-hotel-1.jpg",

  // Only 4 images here
  images: [
    "/images/packages/reykjavik-northern-lights-hotel-1.jpg",
    "/images/packages/reykjavik-northern-lights-hotel-2.jpg",
    "/images/packages/reykjavik-northern-lights-hotel-3.jpg",
    "/images/packages/reykjavik-northern-lights-hotel-4.jpg"
  ],

  rating: 4.8,
  reviews: 1421,
  badge: "AURORA VIEW",
  description: "Designed for winter escapes and northern lights visibility.",
  facilities: ["Aurora View", "Heated Rooms", "Shuttle", "WiFi"]
},


 

  {
  id: 42,
  name: "Ionian Breeze Resort",
  destination: "Corfu, Greece",
  country: "Greece",
  nights: 5,
  boards: [
    { type: "Bed & Breakfast", price: 259 },
    { type: "Half Board", price: 319 },
    { type: "All Inclusive", price: 399 }
  ],

  // Main Image
  image: "/images/packages/ionian-breeze-resort-1.jpg",

  // Gallery Images
  images: [
    "/images/packages/ionian-breeze-resort-1.jpg",
    "/images/packages/ionian-breeze-resort-2.jpg",
    "/images/packages/ionian-breeze-resort-3.jpg",
    "/images/packages/ionian-breeze-resort-4.jpg",
    "/images/packages/ionian-breeze-resort-5.jpg"
  ],

  rating: 4.4,
  reviews: 318,
  badge: "GREEK GETAWAY",
  description: "Seaside resort with traditional Greek character, overlooking crystal-clear Ionian waters.",
  facilities: ["Sea View", "Pool", "Shuttle", "Restaurant"]
},


 {
  id: 46,
  name: "Dubrovnik Old Town Escape",
  destination: "Dubrovnik, Croatia",
  country: "Croatia",
  nights: 4,
  boards: [
    { type: "Bed & Breakfast", price: 249 },
    { type: "Half Board", price: 299 },
    { type: "All Inclusive", price: 379 }
  ],

  // Main image
  image: "/images/packages/dubrovnik-old-town-escape-1.jpg",

  // Gallery images
  images: [
    "/images/packages/dubrovnik-old-town-escape-1.jpg",
    "/images/packages/dubrovnik-old-town-escape-2.jpg",
    "/images/packages/dubrovnik-old-town-escape-3.jpg",
    "/images/packages/dubrovnik-old-town-escape-4.jpg",
    "/images/packages/dubrovnik-old-town-escape-5.jpg"
  ],

  rating: 4.5,
  reviews: 402,
  badge: "HISTORIC STAY",
  description: "Stay within walking distance of Dubrovnik’s medieval walls and Adriatic views.",
  facilities: ["Historic Location", "Tours", "Breakfast", "WiFi"]
},



 {
  id: 48,
  name: "Amalfi Cliffside Hotel",
  destination: "Amalfi Coast, Italy",
  country: "Italy",
  nights: 6,
  boards: [
    { type: "Bed & Breakfast", price: 379 },
    { type: "Half Board", price: 449 },
    { type: "All Inclusive", price: 529 }
  ],

  // Main image
  image: "/images/packages/amalfi-cliffside-hotel-1.jpg",

  // Gallery images
  images: [
    "/images/packages/amalfi-cliffside-hotel-1.jpg",
    "/images/packages/amalfi-cliffside-hotel-2.jpg",
    "/images/packages/amalfi-cliffside-hotel-3.jpg",
    "/images/packages/amalfi-cliffside-hotel-4.jpg",
    "/images/packages/amalfi-cliffside-hotel-5.jpg"
  ],

  rating: 4.7,
  reviews: 474,
  badge: "ROMANTIC VIEWS",
  description: "Classic cliffside hotel with terraces overlooking the Mediterranean—perfect for couples.",
  facilities: ["Terrace Dining", "Sea Views", "Breakfast", "Concierge"]
},



 {
  id: 53,
  name: "Côte d'Azur Luxury Escape",
  destination: "Cannes, France",
  country: "France",
  nights: 6,
  boards: [
    { type: "Bed & Breakfast", price: 449 },
    { type: "Half Board", price: 549 },
    { type: "All Inclusive", price: 629 }
  ],

  // Main image (local)
  image: "/images/packages/cote-dazur-luxury-1.jpg",

  images: [
    "/images/packages/cote-dazur-luxury-1.jpg",
    "/images/packages/cote-dazur-luxury-2.jpg",
    "/images/packages/cote-dazur-luxury-3.jpg",
    "/images/packages/cote-dazur-luxury-4.jpg",
    "/images/packages/cote-dazur-luxury-5.jpg"
  ],

  rating: 4.9,
  reviews: 712,
  badge: "LUXURY PICK",
  description: "Upscale escape in the heart of the Riviera with yacht charters and Michelin dining nearby.",
  facilities: ["Yacht Charters", "Spa", "Fine Dining", "Concierge"]
},




 {
  id: 59,
  name: "Tuscany Countryside Villa",
  destination: "Tuscany, Italy",
  country: "Italy",
  nights: 7,
  boards: [
    { type: "Bed & Breakfast", price: 359 },
    { type: "Half Board", price: 429 },
    { type: "All Inclusive", price: 509 }
  ],

  image: "/images/packages/tuscany-countryside-villa-1.jpg",

  images: [
    "/images/packages/tuscany-countryside-villa-1.jpg",
    "/images/packages/tuscany-countryside-villa-2.jpg",
    "/images/packages/tuscany-countryside-villa-3.jpg",
    "/images/packages/tuscany-countryside-villa-4.jpg",
    "/images/packages/tuscany-countryside-villa-5.jpg"
  ],

  rating: 4.6,
  reviews: 298,
  badge: "COUNTRY LIVING",
  description: "Renovated villa set among rolling vineyards—great for self-catered family stays and wine tours.",
  facilities: ["Private Garden", "BBQ", "Parking", "WiFi"]
},


 {
  id: 61,
  name: "Ocean Pearl Resort",
  destination: "Zanzibar",
  country: "Tanzania",

  image: "/images/packages/ocean-pearl-resort-1.jpg",

  images: [
    "/images/packages/ocean-pearl-resort-1.jpg",
    "/images/packages/ocean-pearl-resort-2.jpg",
    "/images/packages/ocean-pearl-resort-3.jpg"
  ],

  rating: 4.5,
  reviews: 321,
  nights: 7,
  badge: "All Inclusive",
  description: "A luxury beach escape in Zanzibar with white-sand beaches and crystal-clear waters.",
  facilities: ["Beachfront", "Pool", "Spa", "WiFi", "Airport Transfer"],

  boards: [
    { type: "Room Only", price: 699 },
    { type: "Half Board", price: 899 },
    { type: "All Inclusive", price: 1099 }
  ]
},


{
  id: 62,
  name: "Sunset Lagoon Retreat",
  destination: "Cancun",
  country: "Mexico",

  image: "/images/packages/sunset-lagoon-retreat-1.jpg",

  images: [
    "/images/packages/sunset-lagoon-retreat-1.jpg",
    "/images/packages/sunset-lagoon-retreat-2.jpg",
    "/images/packages/sunset-lagoon-retreat-3.jpg"
  ],

  rating: 4.8,
  reviews: 842,
  nights: 6,
  badge: "All Inclusive",

  description: "Experience the Caribbean's turquoise waters with unlimited food, drinks, and premium service.",

  facilities: ["Private Beach", "Bar", "Spa", "Gym", "Kids Club"],

  boards: [
    { type: "Room Only", price: 799 },
    { type: "Half Board", price: 999 },
    { type: "All Inclusive", price: 1299 }
  ]
},


{
  id: 63,
  name: "Paradise Reef Resort",
  destination: "Hurghada",
  country: "Egypt",

  image: "/images/packages/paradise-reef-resort-1.jpg",

  images: [
    "/images/packages/paradise-reef-resort-1.jpg",
    "/images/packages/paradise-reef-resort-2.jpg",
    "/images/packages/paradise-reef-resort-3.jpg"
  ],

  rating: 4.4,
  reviews: 290,
  nights: 7,
  badge: "All Inclusive",

  description: "Crystal-clear Red Sea waters, coral reefs, and a relaxing all-inclusive escape.",

  facilities: ["Beach Access", "Diving", "Pool", "Buffet", "WiFi"],

  boards: [
    { type: "Room Only", price: 499 },
    { type: "Half Board", price: 699 },
    { type: "All Inclusive", price: 899 }
  ]
},


{
  id: 64,
  name: "Emerald Bay Beach Resort",
  destination: "Punta Cana",
  country: "Dominican Republic",

  image: "/images/packages/emerald-bay-beach-resort-1.jpg",

  images: [
    "/images/packages/emerald-bay-beach-resort-1.jpg",
    "/images/packages/emerald-bay-beach-resort-2.jpg",
    "/images/packages/emerald-bay-beach-resort-3.jpg"
  ],

  rating: 4.7,
  reviews: 511,
  nights: 8,
  badge: "All Inclusive",

  description: "Tropical beachfront paradise with premium cocktails and unlimited dining.",

  facilities: ["Private Beach", "Spa", "Pool Bar", "Gym", "Water Sports"],

  boards: [
    { type: "Room Only", price: 999 },
    { type: "Half Board", price: 1199 },
    { type: "All Inclusive", price: 1499 }
  ]
},



{
  id: 66,
  name: "Crystal Cove Resort",
  destination: "Phuket",
  country: "Thailand",

  image: "/images/packages/crystal-cove-resort-1.jpg",

  images: [
    "/images/packages/crystal-cove-resort-1.jpg",
    "/images/packages/crystal-cove-resort-2.jpg",
    "/images/packages/crystal-cove-resort-3.jpg"
  ],

  rating: 4.6,
  reviews: 378,
  nights: 8,
  badge: "All Inclusive",

  description: "Enjoy tropical beaches, Thai cuisine, and unlimited entertainment.",

  facilities: ["Infinity Pool", "Spa", "Bar", "Restaurant", "Gym"],

  boards: [
    { type: "Room Only", price: 699 },
    { type: "Half Board", price: 899 },
    { type: "All Inclusive", price: 1099 }
  ]
},


{
  id: 67,
  name: "Palms Breeze Resort",
  destination: "Bali",
  country: "Indonesia",

  image: "/images/packages/palms-breeze-resort-1.jpg",

  images: [
    "/images/packages/palms-breeze-resort-1.jpg",
    "/images/packages/palms-breeze-resort-2.jpg",
    "/images/packages/palms-breeze-resort-3.jpg"
  ],

  rating: 4.9,
  reviews: 1110,
  nights: 6,
  badge: "All Inclusive",

  description: "Luxury Bali escape with jungle views, ocean pools, and premium services.",

  facilities: ["Spa", "Pool", "Yoga Deck", "Restaurant", "WiFi"],

  boards: [
    { type: "Room Only", price: 899 },
    { type: "Half Board", price: 1099 },
    { type: "All Inclusive", price: 1399 }
  ]
},


{
  id: 68,
  name: "Golden Bay Resort",
  destination: "Cyprus",
  country: "Cyprus",

  image: "/images/packages/golden-bay-resort-1.jpg",

  images: [
    "/images/packages/golden-bay-resort-1.jpg",
    "/images/packages/golden-bay-resort-2.jpg",
    "/images/packages/golden-bay-resort-3.jpg"
  ],

  rating: 4.4,
  reviews: 267,
  nights: 7,
  badge: "All Inclusive",

  description: "A sunny Mediterranean escape with pristine beaches and warm hospitality.",

  facilities: ["WiFi", "Pool", "Restaurant", "Beach Access"],

  boards: [
    { type: "Room Only", price: 499 },
    { type: "Half Board", price: 699 },
    { type: "All Inclusive", price: 899 }
  ]
},


{
  id: 69,
  name: "Lagoon Paradise Resort",
  destination: "Mauritius",
  country: "Mauritius",

  image: "/images/packages/lagoon-paradise-resort-1.jpg",

  images: [
    "/images/packages/lagoon-paradise-resort-1.jpg",
    "/images/packages/lagoon-paradise-resort-2.jpg",
    "/images/packages/lagoon-paradise-resort-3.jpg"
  ],

  rating: 4.8,
  reviews: 402,
  nights: 7,
  badge: "All Inclusive",

  description: "Turquoise lagoons, coral reefs, and world-class dining included.",

  facilities: ["Water Sports", "Spa", "Pool", "Bar", "WiFi"],

  boards: [
    { type: "Room Only", price: 899 },
    { type: "Half Board", price: 1099 },
    { type: "All Inclusive", price: 1399 }
  ]
},


{
  id: 70,
  name: "Coral Sands Beachfront Resort",
  destination: "Maldives",
  country: "Maldives",

  image: "/images/packages/coral-sands-beachfront-resort-1.jpg",

  images: [
    "/images/packages/coral-sands-beachfront-resort-1.jpg",
    "/images/packages/coral-sands-beachfront-resort-2.jpg",
    "/images/packages/coral-sands-beachfront-resort-3.jpg"
  ],

  rating: 5.0,
  reviews: 784,
  nights: 5,
  badge: "All Inclusive",

  description: "Pure luxury — overwater villas, crystal-clear lagoons, and gourmet dining.",

  facilities: ["Water Villas", "Infinity Pool", "Romantic Dining", "Spa"],

  boards: [
    { type: "Room Only", price: 1199 },
    { type: "Half Board", price: 1399 },
    { type: "All Inclusive", price: 1799 }
  ]
},
 
{
  id: 71,
  name: "Berlin City Escape Hotel",
  destination: "Berlin",
  country: "Germany",

  image: "/images/packages/berlin-city-escape-hotel-1.jpg",

  images: [
    "/images/packages/berlin-city-escape-hotel-1.jpg",
    "/images/packages/berlin-city-escape-hotel-2.jpg",
    "/images/packages/berlin-city-escape-hotel-3.jpg",
    "/images/packages/berlin-city-escape-hotel-4.jpg",
    "/images/packages/berlin-city-escape-hotel-5.jpg"
  ],

  rating: 4.4,
  reviews: 874,
  nights: 3,
  badge: "CITY BREAK",

  description: "Modern city hotel close to Alexanderplatz – perfect base for sightseeing, shopping and nightlife.",

  facilities: ["Central Location", "WiFi", "Bar", "Restaurant", "Metro Access"],

  boards: [
    { type: "Room Only", price: 219 },
    { type: "Bed & Breakfast", price: 259 },
    { type: "All Inclusive", price: 309 }
  ]
},


{
  id: 72,
  name: "Brandenburg Gate Boutique Stay",
  destination: "Berlin",
  country: "Germany",

  nights: 3,

  boards: [
    { type: "Bed & Breakfast", price: 259 },
    { type: "Half Board", price: 329 },
    { type: "All Inclusive", price: 379 }
  ],

  image: "/images/packages/brandenburg-gate-boutique-stay-1.jpg",

  images: [
    "/images/packages/brandenburg-gate-boutique-stay-1.jpg",
    "/images/packages/brandenburg-gate-boutique-stay-2.jpg",
    "/images/packages/brandenburg-gate-boutique-stay-3.jpg",
    "/images/packages/brandenburg-gate-boutique-stay-4.jpg",
    "/images/packages/brandenburg-gate-boutique-stay-5.jpg"
  ],

  rating: 4.6,
  reviews: 612,
  badge: "BOUTIQUE STAY",

  description:
    "Stylish boutique hotel a short walk from the Brandenburg Gate and Unter den Linden boulevard.",

  facilities: [
    "Breakfast Included",
    "Boutique Rooms",
    "Bar",
    "24h Reception",
    "WiFi"
  ]
},


{
  id: 73,
  name: "Berlin Budget City Hotel",
  destination: "Berlin",
  country: "Germany",

  nights: 2,

  boards: [
    { type: "Room Only", price: 169 },
    { type: "Bed & Breakfast", price: 199 },
    { type: "All Inclusive", price: 249 }
  ],

  image: "/images/packages/berlin-budget-city-hotel-1.jpg",

  images: [
    "/images/packages/berlin-budget-city-hotel-1.jpg",
    "/images/packages/berlin-budget-city-hotel-2.jpg",
    "/images/packages/berlin-budget-city-hotel-3.jpg",
    "/images/packages/berlin-budget-city-hotel-4.jpg",
    "/images/packages/berlin-budget-city-hotel-5.jpg"
  ],

  rating: 4.2,
  reviews: 533,
  badge: "BUDGET PICK",

  description:
    "Great-value base near Berlin’s transport links – ideal for short breaks and concerts.",

  facilities: [
    "Budget Friendly",
    "WiFi",
    "24h Reception",
    "Snack Bar"
  ]
},


{
  id: 74,
  name: "Spree River Panorama Hotel",
  destination: "Berlin",
  country: "Germany",

  nights: 4,

  boards: [
    { type: "Bed & Breakfast", price: 329 },
    { type: "Half Board", price: 399 },
    { type: "All Inclusive", price: 489 }
  ],

  image: "/images/packages/spree-river-panorama-hotel-1.jpg",

  images: [
    "/images/packages/spree-river-panorama-hotel-1.jpg",
    "/images/packages/spree-river-panorama-hotel-2.jpg",
    "/images/packages/spree-river-panorama-hotel-3.jpg",
    "/images/packages/spree-river-panorama-hotel-4.jpg",
    "/images/packages/spree-river-panorama-hotel-5.jpg"
  ],

  rating: 4.7,
  reviews: 954,
  badge: "RIVER VIEW",

  description:
    "Contemporary waterside hotel overlooking the River Spree with easy tram links into Mitte.",

  facilities: ["River View", "Restaurant", "Bar", "Gym", "WiFi"]
},


{
  id: 75,
  name: "Kreuzberg Nightlife Getaway",
  destination: "Berlin",
  country: "Germany",
  nights: 3,

  boards: [
    { type: "Room Only", price: 239 },
    { type: "Bed & Breakfast", price: 279 },
    { type: "All Inclusive", price: 359 }
  ],

  image: "/images/packages/kreuzberg-nightlife-getaway-1.jpg",

  images: [
    "/images/packages/kreuzberg-nightlife-getaway-1.jpg",
    "/images/packages/kreuzberg-nightlife-getaway-2.jpg",
    "/images/packages/kreuzberg-nightlife-getaway-3.jpg",
    "/images/packages/kreuzberg-nightlife-getaway-4.jpg",
    "/images/packages/kreuzberg-nightlife-getaway-5.jpg"
  ],

  rating: 4.5,
  reviews: 789,
  badge: "NIGHTLIFE",

  description:
    "Trendy hotel in Kreuzberg, close to bars, clubs and street food markets for late-night explorers.",

  facilities: ["Trendy Area", "Bar", "Late Check-In", "WiFi"]
},




];

export default packages;

    







